import { Flex, Typography } from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';
import { IconBrandIconThirdPL } from '../../../IconBrandIconThirdPL';

export const PricingThirdPLDeliveryBadge = ({
  orderDeadline,
}: {
  orderDeadline: string | null;
}) => (
  <Flex.Row gap={4} alignItems={'center'}>
    <Flex
      padding={{ horizontal: 6, vertical: 3 }}
      backgroundColor={'pink3'}
      borderRadius={10}
    >
      <IconBrandIconThirdPL width={41} height={11} />
    </Flex>
    {isNotNil(orderDeadline) && (
      <Typography type={'body4'} color={'content_slate_primary'}>
        {orderDeadline}
      </Typography>
    )}
  </Flex.Row>
);
